import React from 'react';
import Choropleth from '@splunk/dashboard-visualizations/Choropleth';
import GeoRegistry from '@splunk/visualization-context/GeoRegistry';
import GeoJsonProvider from '@splunk/visualization-context/GeoJsonProvider';
import { GeoContextProvider } from '@splunk/visualization-context/GeoContext';

const geoRegistry = GeoRegistry.create();
geoRegistry.addDefaultProvider(new GeoJsonProvider());

const ChoroplethProps = {
    mode: '',
    style: {},
    loading: false,
    width: 800,
    height: 600,
    onOptionsChange: () => {},
    onEventTrigger: () => {},
    onRequestParamsChange: () => {},
    options: {
        name: 'USA',
        source: 'geo://default/world',
        projection: 'equirectangular',
        sourceBounds: { lat: { min: -60, max: 85 }, long: { min: -180, max: 180 } },
        logicalBounds: { x: { min: 0, max: 800 }, y: { min: 0, max: 600 } },
        fillColor: '#EAEFF2',
        strokeColor: '#689C8D',
        strokeHighlightColor: '#000',
        selector: '.feature',
    },
    encoding: {
        featureId: 'primary[0]',
        fill: {
            field: 'primary[1]',
            format: {
                type: 'gradient',
            },
        },
    },
    dataSources: {
        primary: {
            data: {
                columns: [
                    ['United States', 'Russia', 'Australia', 'Brazil', 'Japan', 'China', 'India', 'Canada'],
                    [17, 3, 65, 385, 69, 9, 142, 23],
                ],
                fields: [
                    {
                        name: 'country',
                    },
                    {
                        name: 'value',
                    },
                ],
            },
        },
    },
};

export default () => (
    <GeoContextProvider value={geoRegistry}>
        <Choropleth {...ChoroplethProps} />
    </GeoContextProvider>
);
